module.exports = __webpack_public_path__ + "static/img/format.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/format.png
// module id = W2MG
// module chunks = 0